import { apiFetch } from './api';

// ─── TYPES ──────────────────────────────────────────────────────────────────

export interface AppNotification {
  id: string;
  userId: string;
  title: string;
  body: string;
  /** e.g. 'maintenance' | 'booking' | 'order' | 'warranty' | 'issue' | 'system' */
  type: string;
  isRead: boolean;
  data?: Record<string, unknown> | null;
  createdAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

// ─── API FUNCTIONS ──────────────────────────────────────────────────────────

export const getNotifications = async (): Promise<AppNotification[]> => {
  const res = await apiFetch<ApiResponse<AppNotification[]>>('/v1/notifications');
  return res.data;
};

export const markNotificationRead = async (id: string): Promise<void> => {
  await apiFetch(`/v1/notifications/${id}/read`, { method: 'PUT' });
};

export const markAllNotificationsRead = async (): Promise<void> => {
  await apiFetch('/v1/notifications/read-all', { method: 'PUT' });
};

export const deleteNotification = async (id: string): Promise<void> => {
  await apiFetch(`/v1/notifications/${id}`, { method: 'DELETE' });
};
